<template>
    <div class="content">
        <div class="section">
            <div class="tag flex-row">
                <div class="flex-column">
                    <img src="../../assets/img/btzs-icon.png" />
                    <span>订单信息</span>
                </div>
            </div>
            <div class="info">
                <div class="data">团队订单编号：{{ content.orderSn }}</div>
                <div class="data" v-if="content.orderDetailInfoVOList.length > 0">
                    入馆日期：{{ content.orderDetailInfoVOList[0].playStartDay }}
                </div>
                <div class="data" v-if="content.orderDetailInfoVOList.length > 0">
                    参观时段：{{ content.orderDetailInfoVOList[0].startTime }}-{{
                        content.orderDetailInfoVOList[0].endTime
                    }}
                </div>
                <div class="data flex-row" v-if="content.orderStatus == 6">
                    订单状态：<span style="color: #bb2916; font-weight: 600">审核中</span>
                    <!-- <div class="tip">
                        重要提醒：团队订单需参观日到四川大学博物馆售票窗口进行审核，审核通过后即可支付。
                    </div> -->
                </div>
                <div class="data flex-row" v-if="content.orderStatus == 7">
                    订单状态：<span style="color: #bb2916">审核未通过</span>
                    <div class="tip" style="background: #fff8f8; color: #e34d59">
                        {{ content.auditRemark }}
                    </div>
                </div>
                <div class="data">
                    订单总价： <span style="color: #bb2916">￥{{ content.totalAmount }}</span>
                </div>
            </div>
            <div class="table">
                <div class="tableHeader flex-row">
                    <div class="item name">参观团队</div>
                    <div class="item">领队人员</div>
                    <!-- <div class="item idCard">证件号码</div> -->
                    <div class="item phone">联系电话</div>
                    <div class="item">门票名称</div>
                    <div class="item">参观总数</div>
                    <!-- <div class="item">人员名单</div> -->
                </div>
                <div class="tBody">
                    <div
                        class="th flex-row"
                        v-for="(item, index) in content.orderDetailInfoVOList"
                        :key="index"
                    >
                        <div class="data name ellipsis1">
                            {{ content.teamName }}
                        </div>
                        <div class="data">
                            {{ content.contact }}
                        </div>
                        <!-- <div class="data idCard">
                            {{ content.customerIdCard }}
                        </div> -->
                        <div class="data phone">
                            {{ content.contactNumber }}
                        </div>
                        <div class="data">
                            {{ item.productName }}
                        </div>
                        <div class="data">
                            {{ item.productQuantity }}
                        </div>
                        <!-- <div
                            class="data cursorp"
                            style="color: #bb2916; text-decoration: underline"
                            @click="showPerson(item.museumOrderUserVOS)"
                        >
                            点击查看
                        </div> -->
                    </div>
                </div>
            </div>
            <div class="tag flex-row">
                <div class="flex-column">
                    <img src="../../assets/img/btzs-icon.png" />
                    <span>温馨提示</span>
                </div>
            </div>
            <div class="detail">
                <div class="item flex-row">
                    <img src="../../assets/img/icon-tip1.png" />
                    团队需至少提前三天在四川大学博物馆官网或微信公众号预约购票，到团当日无法预约当天票。
                </div>
                <div class="item flex-row">
                    <img src="../../assets/img/icon-tip1.png" />
                    参观日请联系人提前组织好团队，按照二维码下方的进场时间从团队入口有序扫码进场，超过预约时间30分钟，二维码失效，无法入场。
                </div>
                <div class="item flex-row">
                    <img src="../../assets/img/icon-tip1.png" />
                    开馆时间:09:00，停止入馆时间:16:30，闭馆时间:17:00。
                </div>
                <div class="item flex-row">
                    <img src="../../assets/img/icon-tip1.png" />
                    咨询电话028-85412543，028-85400772。
                </div>
            </div>
            <img class="line" src="../../assets/img/icon-line.svg" />
            <div class="btnbox flex-row">
                <div class="backbtn cursorp" @click="CancelOrder" v-if="content.orderStatus == 6">
                    取消预约
                </div>
                <div class="backbtn cursorp" @click="toHome" v-if="content.orderStatus == 7">
                    重新预约
                </div>
                <div class="prevbtn cursorp" @click="toPage">返回</div>
            </div>
        </div>
        <!-- 人员名单弹窗 -->
        <PersonList
            :isShowPerson="isShowPerson"
            :tableData="list"
            @changeDialog="getData"
        ></PersonList>
    </div>
</template>

<script>
import { getOrderDetail, merchantNo, CancelOrder } from "../../utils/http.js";
// 引入公共的bus，来做为中间传达的工具
import { eventBus } from "../../utils/eventBus.js";
import PersonList from "@/components/Dialog/PersonList.vue"; //人员名单列表
export default {
    name: "OrderReview",
    components: {
        PersonList,
    },
    data() {
        return {
            list: [],
            radio: "",
            isShowPerson: false,
            content: {
                orderDetailInfoVOList: [],
            },
        };
    },
    mounted() {
        let orderNo = this.$route.query.orderNo;
        this.getOrderDetail({
            orderSn: orderNo,
        });
    },
    methods: {
        // 获取订单详情
        getOrderDetail(param) {
            getOrderDetail(param).then(res => {
                this.content = res.data;
            });
        },
        // 取消预约
        CancelOrder() {
            let that = this;
            this.$confirm("是否确认取消预约?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                customClass: "confirm",
                type: "warning",
            })
                .then(() => {
                    let param = {
                        merchantNo: merchantNo, //商户号
                        orderSn: that.content.orderSn, //订单号
                    };
                    CancelOrder(param).then(res => {
                        this.$message({
                            message: "取消成功",
                            type: "success",
                            offset: "400",
                            duration: "1000",
                        });
                        setTimeout(() => {
                            // 返回上一页并且刷新页面
                            this.$router.go(-1);
                        }, 1500);
                    });
                })
                .catch(() => {});
        },
        //点击返回
        toPage() {
            this.$router.back();
        },
        // 点击跳转首页
        toHome() {
            //利用事件总线传递到首页
            eventBus.$emit("setcurrentTab", "0");
            this.$router.push("/Home");
        },
        // 点击查看人员名单
        showPerson(list) {
            this.isShowPerson = true;
            this.list = list;
        },
        // 获取子组件传递的值
        getData(val) {
            this.isShowPerson = val;
        },
    },
};
</script>

<style scoped>
.content {
    width: 1200px;
    margin: auto;
    background: #fff;
    background-size: 100%;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
    border-radius: 6px;
    padding: 24px;
    box-sizing: border-box;
}

.section {
    width: 100%;
}

.section .info {
    width: 1007px;
    margin-left: 60px;
    margin-bottom: 8px;
    position: relative;
}

.section .info .data {
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #333;
    margin-bottom: 20px;
}

.info .tip {
    height: 24px;
    background: #fff;
    border-radius: 12px;
    line-height: 24px;
    padding: 0 8px;
    box-sizing: border-box;
    margin-left: 14px;
    font-size: 12px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #bb2916;
    border: 1px solid #bb2916;
}

.section .table {
    width: 1007px;
    padding: 0 60px;
    box-sizing: border-box;
    margin-bottom: 24px;
}

.table .tableHeader {
    width: 1007px;
    height: 64px;
    border-radius: 6px 6px 0px 0px;
    background-image: url("../../assets/img/tableBG.svg");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    justify-content: space-between;
}

.table .tableHeader .item {
    font-size: 16px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    width: 127px;
    text-align: center;
}

.table .name,
.idCard,
.phone {
    width: 187px !important;
}

.table .tBody {
    width: 1007px;
    border: 1px solid #f1f1f1;
}

.table .tBody .th {
    width: 100%;
    height: 63px;
    justify-content: space-between;
    background: #ffffff;
    border-bottom: 1px solid #f1f1f1;
}

.table .tBody .th:last-child {
    border: none !important;
}

.tBody .th .data {
    font-size: 16px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    width: 127px;
    text-align: center;
    padding: 0 6px;
    box-sizing: border-box;
}

.section .detail {
    margin: 24px 0;
    margin-left: 60px;
}

.detail .item {
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #333;
    margin-bottom: 20px;
}

.detail .item img {
    width: 14px;
    height: 14px;
    margin-right: 4px;
}

.line {
    width: 1038px;
    height: 6px;
    margin: 24px 0;
    margin-left: 60px;
}

.btnbox {
    justify-content: center;
}

.btnbox div {
    width: 324px;
    height: 60px;
    font-size: 22px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    text-align: center;
    line-height: 60px;
    border-radius: 30px;
}

.btnbox .backbtn {
    color: #bb2916;
    background: #ffffff;
    border: 1px solid #bb2916;
}

.btnbox .prevbtn {
    color: #ffffff;
    background: #bb2916;
    margin-left: 32px;
}
</style>
